

import React, { useCallback, useState } from 'react';
import { Container, Block } from './styles'

import IconBefore from '../../assets/pagination/chevron-left.svg'
import IconNext from '../../assets/pagination/chevron-right.svg'
import IconFirst from '../../assets/pagination/chevrons-left.svg'
import IconLast from '../../assets/pagination/chevrons-right.svg'
import { useEffect } from 'react';

type PaginationProps = {
    data: any[];
    handleLoadPagination(data: any[]): void
    itemPerPageProps?: number;
};
const Pagination: React.FC<PaginationProps> = ({ data, handleLoadPagination, itemPerPageProps }) => {

    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)

    const [disabledNext, setDisabledNext] = useState(false)
    const [disabledBefore, setDisabledBefore] = useState(false)
    const [disabledLast, setDisabledLast] = useState(false)
    const [disabledFirst, setDisabledFirst] = useState(false)

    const [firstRegister, setFirstRegister] = useState(0)
    const [lastRegister, setLastRegister] = useState(0)

    const [itensPerPage] = useState(itemPerPageProps? itemPerPageProps: 20)


    //first
    useEffect(() => {

        if (data.length !== 0) {

            const qtdPages = Math.ceil(data.length / itensPerPage)
            setTotalPages(qtdPages)

            setTotalRegister(data.length)

            // if current page 0, 'cause after first render, just in this case return to position 1
            if (currentPage === 0) {
                setCurrentPage(1)
            }

        } else {
            setCurrentPage(0);
        }



    }, [data, itensPerPage, currentPage])



    //action of button
    const handleNext = useCallback(() => {
        setCurrentPage(currentPage + 1)
    }, [currentPage])
    const handleBefore = useCallback(() => {
        setCurrentPage(currentPage - 1)
    }, [currentPage])
    const handleFirst = useCallback(() => {
        setCurrentPage(1)
    }, [])
    const handleLast = useCallback(() => {
        setCurrentPage(totalPages)
    }, [totalPages])


    //set buttons
    useEffect(() => {

        if (currentPage === 0) {
            setDisabledBefore(true)
            setDisabledFirst(true)
            setDisabledNext(true)
            setDisabledLast(true)
        } else {
            if (currentPage === 1) {
                setDisabledBefore(true)
                setDisabledFirst(true)
            } else {
                setDisabledBefore(false)
                setDisabledFirst(false)
            }
            if (currentPage === totalPages) {
                setDisabledNext(true)
                setDisabledLast(true)

            } else {
                setDisabledNext(false)
                setDisabledLast(false)
            }

        }

    }, [currentPage, totalPages])



    //set register and update datas
    useEffect(() => {

        let firstRegisterHere = 1;
        let LastRegisterHere = 0;

        if (totalRegister !== 0) {
            firstRegisterHere = ((currentPage - 1) * itensPerPage) + 1
            if (currentPage === totalPages) {
                LastRegisterHere = totalRegister
            } else {
                LastRegisterHere = firstRegisterHere + itensPerPage - 1
            }
        }

        setFirstRegister(firstRegisterHere)
        setLastRegister(LastRegisterHere)

        const dataSelected = data.slice(firstRegisterHere - 1, LastRegisterHere)

        //Treats when you reduce the qty of pages being ahead
        if (currentPage > totalPages && currentPage > 1) {
            setCurrentPage(1)
        }
        if (currentPage === 0) {
            setTotalPages(0)
        }




        handleLoadPagination(dataSelected)

    }, [currentPage, itensPerPage, totalPages, data, handleLoadPagination, totalRegister])


    // //changing register/page
    // const handleChageIterPerPage = useCallback((e) => {
    //     if (e.value === "Todos") {
    //         setItensPerPage(Number(totalRegister))
    //     } else {
    //         setItensPerPage(Number(e.value))
    //     }
    // }, [totalRegister])



    return (
        <Container>
            <Block>
                {totalRegister === 0 && (<p>Não há elementos a serem mostrados</p>)}
                {totalRegister !== 0 && (<p>Monstrando desde {`${firstRegister} ao ${lastRegister} de ${totalRegister} elementos`}</p>)}
            </Block>

            {/* it'd necessary trate error 'cause tr null's */}
            {/* <Form ref={formRef} onSubmit={() => { }} >
                <label>Registro por páginas</label>
                <Select
                    id='select'
                    placeHolder='Ano'
                    name="year"
                    defaultValue={{ label: 5, value: 5 }}
                    options={[
                        { label: "5", value: "5" },
                        { label: "10", value: "10" },
                        { label: "15", value: "15" },
                        { label: "20", value: "25" },
                        { label: 'Todos', value: "Todos" }
                    ]}
                    onChange={handleChageIterPerPage}
                />
            </Form> */}
            <Block>
                <button title="Primeiro" disabled={disabledFirst} onClick={handleFirst}><img src={IconFirst} alt="primeiro" /> </button>
                <button title="Anterior" disabled={disabledBefore} onClick={handleBefore}> <img src={IconBefore} alt="anterior" /> </button>
                <div title="Página atual / Total de páginas"><p>{` ${currentPage} / ${totalPages} `}</p></div>
                <button title="Próximo" disabled={disabledNext} onClick={handleNext}> <img src={IconNext} alt="proximo" /> </button>
                <button title="Último" disabled={disabledLast} onClick={handleLast}> <img src={IconLast} alt="ultimo" /> </button>
            </Block>

        </Container >
    );
};


export default Pagination;